import { BadgesApi } from '@/api';
import { Badge } from '@/models';
import { BadgesCount, GeekProfileBadge } from '@/models/geek-profile';
import { Module } from 'vuex';
import { Actions } from './actions';
import { RootState } from './root.store';
import { Mutations } from './mutations';

export interface BadgesState {
  allBadges: Badge[];
  badgesCount: BadgesCount;
  geeksBadges: GeekProfileBadge[];
}

const badgesApi = new BadgesApi();

export const BadgesModule: Module<BadgesState, RootState> = {
  state: {
    allBadges: [],
    badgesCount: {
      bronzeBadgesCount: 0,
      silverBadgesCount: 0,
      goldBadgesCount: 0,
    },
    geeksBadges: [],
  },

  mutations: {
    [Mutations.badges.setBadges](state, badges: Badge[]) {
      state.allBadges = badges;
    },
    [Mutations.badges.setGeekBadgesCount](state, badgesCount: BadgesCount) {
      state.badgesCount = badgesCount;
    },
    [Mutations.badges.setGeekBadges](state, badges: GeekProfileBadge[]) {
      state.geeksBadges = badges;
    },
  },

  actions: {
    async [Actions.badges.fetchBadges]({ commit }): Promise<void> {
      const badges = await badgesApi.fetchBadges();
      commit(Mutations.badges.setBadges, badges);
    },
    async [Actions.badges.fetchGeekBadgesCount]({ commit }, geekId: string): Promise<void> {
      const geekBadgesCount = await badgesApi.fetchGeekBadgesCount(geekId);
      commit(Mutations.badges.setGeekBadgesCount, geekBadgesCount);
    },
    async [Actions.badges.fetchGeekBadges]({ commit }, geekId: string): Promise<void> {
      const geekBadges = await badgesApi.fetchGeekBadges(geekId);
      commit(Mutations.badges.setGeekBadges, geekBadges);
    },
    [Actions.badges.resetGeekBadgesCount]({ commit }) {
      commit(Mutations.badges.setGeekBadgesCount, {});
    },
  },
};
